function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64355",
  "data-name": "Path 64355",
  d: "M124.016,84.958H121.3V79.835h2.646a1.608,1.608,0,0,1,1.126.372,1.213,1.213,0,0,1,.408.934,1.163,1.163,0,0,1-.271.779,1.135,1.135,0,0,1-.665.4,1.145,1.145,0,0,1,.738.426,1.273,1.273,0,0,1,.3.833,1.3,1.3,0,0,1-.416,1A1.629,1.629,0,0,1,124.016,84.958Zm-.266-3a.8.8,0,0,0,.557-.183.672.672,0,0,0,0-.96.793.793,0,0,0-.557-.185h-1.508v1.328Zm.041,2.213a.9.9,0,0,0,.6-.188.717.717,0,0,0,0-1.029.849.849,0,0,0-.6-.2h-1.549v1.421Z",
  transform: "translate(-121.297 -79.75)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64356",
  "data-name": "Path 64356",
  d: "M130.967,84.958h-.944V82.83l-2.09-3h1.081l1.485,2.2,1.469-2.2h1.081l-2.081,3Z",
  transform: "translate(-123.27 -79.75)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64357",
  "data-name": "Path 64357",
  d: "M144.593,84.958h-.944v-3.8L142,84.958h-.4l-1.646-3.8v3.8H139V79.835h1.332l1.459,3.372,1.469-3.372h1.331Z",
  transform: "translate(-126.561 -79.75)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64358",
  "data-name": "Path 64358",
  d: "M152.276,84.958h-3.687V79.835h3.687v.791h-2.743v1.328h2.687v.792h-2.687v1.421h2.743Z",
  transform: "translate(-129.412 -79.75)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64359",
  "data-name": "Path 64359",
  d: "M157.694,85.015a2.87,2.87,0,0,1-2.018-.742,2.663,2.663,0,0,1,0-3.818,2.872,2.872,0,0,1,2.018-.741,2.439,2.439,0,0,1,2.162,1.152l-.807.392a1.53,1.53,0,0,0-.568-.538,1.564,1.564,0,0,0-.786-.208,1.812,1.812,0,0,0-1.328.523,1.937,1.937,0,0,0,0,2.657,1.812,1.812,0,0,0,1.328.523,1.567,1.567,0,0,0,.791-.208,1.539,1.539,0,0,0,.564-.538l.807.392A2.464,2.464,0,0,1,157.694,85.015Z",
  transform: "translate(-131.279 -79.714)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64360",
  "data-name": "Path 64360",
  d: "M167.732,84.958h-.944V82.724h-2.8v2.234h-.944V79.835h.944v2.1h2.8v-2.1h.944Z",
  transform: "translate(-133.71 -79.75)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64361",
  "data-name": "Path 64361",
  d: "M175.948,84.958h-1.073l-.4-.983h-2.468l-.4.983h-1.073l2.114-5.123h1.178Zm-1.734-1.774-.969-2.442-.968,2.442Z",
  transform: "translate(-135.939 -79.75)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64362",
  "data-name": "Path 64362",
  d: "M183.736,84.958h-.911L180.017,81.3v3.656h-.944V79.835h.968l2.751,3.557V79.835h.944Z",
  transform: "translate(-138.476 -79.75)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64363",
  "data-name": "Path 64363",
  d: "M188.283,84.958h-.944V79.835h.944Z",
  transform: "translate(-140.934 -79.75)",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64364",
  "data-name": "Path 64364",
  d: "M192.793,85.015a2.869,2.869,0,0,1-2.018-.742,2.663,2.663,0,0,1,0-3.818,2.872,2.872,0,0,1,2.018-.741,2.439,2.439,0,0,1,2.162,1.152l-.807.392a1.529,1.529,0,0,0-.568-.538,1.564,1.564,0,0,0-.786-.208,1.812,1.812,0,0,0-1.328.523,1.937,1.937,0,0,0,0,2.657,1.812,1.812,0,0,0,1.328.523,1.567,1.567,0,0,0,.79-.208,1.538,1.538,0,0,0,.564-.538l.807.392A2.464,2.464,0,0,1,192.793,85.015Z",
  transform: "translate(-141.715 -79.714)",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64365",
  "data-name": "Path 64365",
  d: "M205.7,84.958h-1.073l-.395-.983h-2.469l-.395.983H200.29l2.114-5.123h1.178Zm-1.735-1.774-.968-2.442-.968,2.442Z",
  transform: "translate(-144.784 -79.75)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64366",
  "data-name": "Path 64366",
  d: "M210.822,84.958h-2V79.835h2a2.9,2.9,0,0,1,2.033.714,2.576,2.576,0,0,1,0,3.695A2.9,2.9,0,0,1,210.822,84.958Zm0-.791a1.81,1.81,0,0,0,1.348-.507,1.724,1.724,0,0,0,.5-1.261,1.752,1.752,0,0,0-.488-1.275,1.813,1.813,0,0,0-1.36-.5h-1.057v3.541Z",
  transform: "translate(-147.321 -79.75)",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64367",
  "data-name": "Path 64367",
  d: "M219.461,84.958h-1.178l-2.114-5.123h1.072l1.63,4.148,1.63-4.148h1.072Z",
  transform: "translate(-149.506 -79.75)",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64368",
  "data-name": "Path 64368",
  d: "M225.644,84.958H224.7V79.835h.944Z",
  transform: "translate(-152.042 -79.75)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64369",
  "data-name": "Path 64369",
  d: "M229.367,85.018a2.921,2.921,0,0,1-2.186-.814l.523-.691a2.3,2.3,0,0,0,1.7.707,1.318,1.318,0,0,0,.81-.208.6.6,0,0,0,.271-.491.522.522,0,0,0-.323-.464,2.963,2.963,0,0,0-.783-.273c-.307-.067-.614-.147-.924-.239a1.79,1.79,0,0,1-.786-.469,1.166,1.166,0,0,1-.323-.852,1.31,1.31,0,0,1,.545-1.072,2.234,2.234,0,0,1,1.417-.427,2.856,2.856,0,0,1,2.017.715l-.54.669a2.168,2.168,0,0,0-1.557-.584,1.135,1.135,0,0,0-.666.173.54.54,0,0,0-.245.464.39.39,0,0,0,.173.322,1.4,1.4,0,0,0,.448.211c.183.054.386.107.609.157s.446.115.67.188a3.182,3.182,0,0,1,.609.273,1.254,1.254,0,0,1,.621,1.121,1.425,1.425,0,0,1-.524,1.137A2.351,2.351,0,0,1,229.367,85.018Z",
  transform: "translate(-152.78 -79.717)",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64370",
  "data-name": "Path 64370",
  d: "M238.878,84.265a2.98,2.98,0,0,1-3.953,0,2.721,2.721,0,0,1,0-3.8,2.982,2.982,0,0,1,3.953,0,2.719,2.719,0,0,1,0,3.8Zm-1.977-.049a1.684,1.684,0,0,0,1.291-.527,2.035,2.035,0,0,0,0-2.653,1.86,1.86,0,0,0-2.586,0,2.054,2.054,0,0,0,0,2.657A1.688,1.688,0,0,0,236.9,84.216Z",
  transform: "translate(-154.852 -79.714)",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64371",
  "data-name": "Path 64371",
  d: "M247.44,84.958h-1.089l-1.194-1.913h-.936v1.913h-.944V79.835h2.364a1.809,1.809,0,0,1,1.275.445,1.5,1.5,0,0,1,.484,1.159,1.433,1.433,0,0,1-.371,1.034,1.562,1.562,0,0,1-.9.473Zm-1.928-2.7a.975.975,0,0,0,.661-.223.806.806,0,0,0,0-1.183.972.972,0,0,0-.661-.223h-1.291v1.629Z",
  transform: "translate(-157.566 -79.75)",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "Group_37879",
  "data-name": "Group 37879",
  transform: "translate(0.023)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64374",
  "data-name": "Path 64374",
  d: "M132.669,49.234a8.764,8.764,0,0,1,2.854.67,4.845,4.845,0,0,1,1.762,1.283,4.43,4.43,0,0,1,.881,1.724,7.737,7.737,0,0,1,.249,1.953v.575a5.175,5.175,0,0,1-2.03,4.425q-2.031,1.514-6.32,1.513H126.1q-1.169,0-2.394-.019t-2.376-.058l.767-4.061q1.953.039,4.175.058t3.985.019a5.624,5.624,0,0,0,2.624-.422,1.591,1.591,0,0,0,.709-1.494,1.81,1.81,0,0,0-.441-1.3,3.359,3.359,0,0,0-1.973-.613l-4.214-.345a7.258,7.258,0,0,1-2.548-.613,5.338,5.338,0,0,1-1.724-1.245,4.425,4.425,0,0,1-.957-1.686,6.668,6.668,0,0,1-.288-1.972V47.05a5.153,5.153,0,0,1,1.859-4.234q1.857-1.512,6.263-1.513,1.647,0,3.6.019t4.827.058l-.767,4.061q-1.686-.038-2.95-.058t-2.2-.019h-2.931a5.238,5.238,0,0,0-2.336.364,1.342,1.342,0,0,0-.651,1.283A1.657,1.657,0,0,0,126.6,48.3a3.945,3.945,0,0,0,2.049.555Z",
  transform: "translate(-121.329 -35.941)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64375",
  "data-name": "Path 64375",
  d: "M161.826,59.032h-3.1a18.793,18.793,0,0,1-3.965-.345,5.035,5.035,0,0,1-2.452-1.206,4.573,4.573,0,0,1-1.245-2.317,16.137,16.137,0,0,1-.345-3.64V34.476l4.98-.8v5.44h7.164l-.8,4.1H155.7v8.046a10.723,10.723,0,0,0,.133,1.877,2.256,2.256,0,0,0,.5,1.131,1.828,1.828,0,0,0,1.034.536,8.9,8.9,0,0,0,1.705.134h3.563Z",
  transform: "translate(-130.066 -33.671)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64376",
  "data-name": "Path 64376",
  d: "M176.3,52.8a13.553,13.553,0,0,0,.153,2.26,2.32,2.32,0,0,0,1.954,2.069,10.358,10.358,0,0,0,2.221.192H183.7q1.724,0,4.253-.077l-.767,3.831q-1.073.038-1.915.058c-.562.013-1.106.019-1.629.019H180.4a13.832,13.832,0,0,1-4.482-.613,6.045,6.045,0,0,1-4.195-4.578,16.3,16.3,0,0,1-.4-3.812V50a17.6,17.6,0,0,1,.421-4.061,6.854,6.854,0,0,1,1.475-2.968,6.469,6.469,0,0,1,2.835-1.82,14.037,14.037,0,0,1,4.5-.613,13.463,13.463,0,0,1,4.2.556,6.855,6.855,0,0,1,2.681,1.551A5.575,5.575,0,0,1,188.869,45a10.006,10.006,0,0,1,.422,2.969v.651a12.09,12.09,0,0,1-.154,2.126,2.908,2.908,0,0,1-.518,1.283,1.726,1.726,0,0,1-.937.613,5.609,5.609,0,0,1-1.418.153Zm4.137-8.505a8.6,8.6,0,0,0-2.107.211,2.372,2.372,0,0,0-1.266.767,3.076,3.076,0,0,0-.612,1.494,15.277,15.277,0,0,0-.153,2.394h8.237v-.88a7.846,7.846,0,0,0-.193-1.878,2.557,2.557,0,0,0-.651-1.225,2.717,2.717,0,0,0-1.264-.671A8.03,8.03,0,0,0,180.441,44.294Z",
  transform: "translate(-136.194 -35.713)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64377",
  "data-name": "Path 64377",
  d: "M205.744,52.8a13.553,13.553,0,0,0,.153,2.26,2.32,2.32,0,0,0,1.954,2.069,10.358,10.358,0,0,0,2.221.192h3.066q1.723,0,4.252-.077l-.767,3.831q-1.072.038-1.915.058t-1.629.019h-3.236a13.832,13.832,0,0,1-4.482-.613,6.045,6.045,0,0,1-4.195-4.578,16.3,16.3,0,0,1-.4-3.812V50a17.6,17.6,0,0,1,.421-4.061,6.853,6.853,0,0,1,1.475-2.968,6.468,6.468,0,0,1,2.835-1.82,14.039,14.039,0,0,1,4.5-.613,13.461,13.461,0,0,1,4.195.556,6.855,6.855,0,0,1,2.681,1.551A5.568,5.568,0,0,1,218.31,45a10.006,10.006,0,0,1,.422,2.969v.651a12.022,12.022,0,0,1-.154,2.126,2.908,2.908,0,0,1-.517,1.283,1.731,1.731,0,0,1-.938.613,5.609,5.609,0,0,1-1.418.153Zm4.137-8.505a8.6,8.6,0,0,0-2.107.211,2.368,2.368,0,0,0-1.265.767,3.076,3.076,0,0,0-.613,1.494,15.277,15.277,0,0,0-.153,2.394h8.237v-.88a7.886,7.886,0,0,0-.192-1.878,2.568,2.568,0,0,0-.651-1.225,2.723,2.723,0,0,0-1.264-.671A8.039,8.039,0,0,0,209.882,44.294Z",
  transform: "translate(-144.948 -35.713)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64378",
  "data-name": "Path 64378",
  d: "M236.275,61.3h-4.981V48.2a8.62,8.62,0,0,1,.536-3.236,5.015,5.015,0,0,1,1.571-2.127,6.633,6.633,0,0,1,2.528-1.169,14.476,14.476,0,0,1,3.41-.363h2.49q1.033,0,2.03.038l-.8,4.137q-.767-.037-1.685-.057t-1.533-.019a6.278,6.278,0,0,0-1.915.23,2.38,2.38,0,0,0-1.073.67,2.1,2.1,0,0,0-.479,1.111,11.407,11.407,0,0,0-.1,1.589Z",
  transform: "translate(-154.026 -35.941)",
  fill: "#fff"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "logo",
  transform: "translate(201 -0.024)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_34575",
  "data-name": "Group 34575"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61535",
  "data-name": "Path 61535",
  d: "M37.216,2H12.405L0,23.489,12.405,44.973h24.81L49.621,23.489ZM29.573,35.554H12.751l1.132-6H28.071v1.666l4.955-3.236-4.955-3.236v1.733H20.048a7.535,7.535,0,0,1,0-15.069H36.874l-1.132,6H21.568V15.681l-4.955,3.236,4.955,3.237V20.489h8.006a7.535,7.535,0,0,1,0,15.069h0Z",
  transform: "translate(0 -1.999)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_34573",
  "data-name": "Group 34573",
  transform: "translate(20.722 38.541)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62795",
  "data-name": "Path 62795",
  d: "M63.692,71.9H42.7l-5.12,8.867H58.57Z",
  transform: "translate(-37.584 -71.903)",
  fill: "#005cff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62796",
  "data-name": "Path 62796",
  d: "M40.144,79.944H61.13l-2.56,4.434H37.584Z",
  transform: "translate(-37.584 -75.511)",
  fill: "#ffd400"
}))));

var SvgSteerLogo = function SvgSteerLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 47.408,
    viewBox: "0 0 150 47.408",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_37887",
    "data-name": "Group 37887",
    transform: "translate(-201 0.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(261.125 2.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37877",
    "data-name": "Group 37877",
    transform: "translate(0 32.353)",
    style: {
      isolation: "isolate"
    }
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18), _ref19), _ref20));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteerLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steer-logo.f240a311.svg";
export { ForwardRef as ReactComponent };